<template>
  <v-layout
    class="white"
    align-space-between
    justify-start
    column
    fill-height
  >
    <v-flex
      shrink
      class="sz_background_light"
      py-3
    >
      <v-flex
        md10
        offset-md1
        sm12
        offset-sm0
      >
        <v-layout>
          <v-flex shrink>
            <AppLogo width="60" />
          </v-flex>
          <v-flex ml-5>
            <h1 class="display-4">
              {{ $t('sheet.sheet_two.title') }}
            </h1>
            <h2 class="display-1 fw-400">
              {{ $t('sheet.sheet_two.subtitle') }}
            </h2>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
    <v-flex v-if="isSheetTwoLoading === true || resourceTwoLoading === true">
      <PageLoader />
    </v-flex>
    <v-flex v-else-if="!resourceTwoLoading">
      <v-flex
        id="sheet-container"
        md10
        offset-md1
        sm12
        offset-sm0
      >
        <v-layout
          :mt-5="smAndUp"
          class="stepper__wrapper"
          mb-0
          fill-height
        >
          <v-flex
            v-if="$vuetify.breakpoint.smAndUp"
            pa-4
            sm3
            class="stepper__header"
          >
            <sheetTableOfContents :show-numbers="false" />
          </v-flex>
          <v-dialog
            v-else
            v-model="contentDialog"
            hide-overlay
            persistent
            scrollable
            fullscreen
          >
            <v-layout
              style="background: #fff; overflow: scroll"
              fill-height
            >
              <sheetTableOfContents
                :show-numbers="false"
                @closeDialog="contentDialog = false"
              />
            </v-layout>
          </v-dialog>
          <v-flex
            px-4
            pt-4
            pb-0
            xs12
            sm9
            :class="isCurrentEdition ? 'white' : 'deprecated deprecated_background'"
          >
            <v-layout
              v-if="$vuetify.breakpoint.xsOnly"
              align-center
              justify-space-between
              class="pb-3"
            >
              <v-flex>
                <a
                  class="link_iconed"
                  @click="goToFamilyCard"
                >
                  <v-icon>keyboard_arrow_left</v-icon> {{ $t('sheet.cancel_button') }}</a>
              </v-flex>
              <v-flex shrink>
                <a @click="contentDialog = true">
                  <BaseIcon>
                    <MenuIcon />
                  </BaseIcon>
                </a>
              </v-flex>
            </v-layout>
            <v-layout
              v-if="!isSheetTwoLoading"
              id="content-area"
              column
              fill-height
              pb-3
              :class="[{ 'pt-3': $vuetify.breakpoint.xsOnly }]"
            >
              <FillInstruction
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <FirstMeeting
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <ChangeNames
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <SheetFood
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <CleaningProducts
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <SheetClothing
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <SchoolSupplies
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <ApartmentEquipment
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <HouseholdAppliances
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <OtherMaterialNeeds
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <IntangibleNeeds
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <SpecialGifts
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <ImportantNeeds
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <SheetTwoConsents
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <SheetTwoVolunteers
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <SheetReflection
                v-view="viewHandler"
                :read-only="readOnly"
              />
              <SheetEndButtons
                :next-section-name="nextSectionName"
                :sheet-type="'needs'"
                :family-id="$route.params.familyId"
                :to="nextSectionId"
                :read-only="readOnly"
                :scroll-button="true"
                :can-do-audit-in-area="canDoAuditInArea"
                :can-do-audit-on-national="canDoAuditOnNational"
                :national-correcting-permission="hasPermissionsForNationalCorrecting"
              />
            </v-layout>
            <FamilyAudit
              v-if="showAuditCard"
              :can-add-comment="canAddComment"
              :family-id="$route.params.familyId"
              :sheet-type="'needs'"
              :comment-level="commentLevel"
              :has-permissions-to-add-comment="hasPermissionsToAddComment"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
    <AppModal
      :visible="partialDataError"
      :close-button="false"
      persistent
    >
      <template #title>
        <v-layout align-center>
          <h2 class="display-3 display-3_dark">
            {{ $t('sheet.sheet_two.partial_data_modal.title') }}
          </h2>
        </v-layout>
      </template>
      <template #content>
        <v-layout align-center>
          <p class="text-xs-left f-16 sz_grafit--text ma-0 mt-1 font-weight-regular">
            {{ $t('sheet.sheet_two.partial_data_modal.content') }}
          </p>
        </v-layout>
      </template>
      <template #actions>
        <v-layout justify-end>
          <v-btn
            color="sz_violet"
            @click="$router.go()"
          >
            {{ $t('sheet.sheet_two.partial_data_modal.button') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
    <leaveConfirmDialog ref="confirm" />
  </v-layout>
</template>

<script>
import FamilyAudit from '@/components/audit/FamilyAudit';
import ApartmentEquipment from '@/components/sheet/sheetTwo/ApartmentEquipment';
import ChangeNames from '@/components/sheet/sheetTwo/ChangeNames';
import CleaningProducts from '@/components/sheet/sheetTwo/CleaningProducts';
import SheetClothing from '@/components/sheet/sheetTwo/SheetClothing';
import SheetTwoConsents from '@/components/sheet/sheetTwo/SheetTwoConsents';
import FillInstruction from '@/components/sheet/sheetTwo/FillInstruction';
import FirstMeeting from '@/components/sheet/sheetTwo/FirstMeeting';
import SheetFood from '@/components/sheet/sheetTwo/SheetFood';
import HouseholdAppliances from '@/components/sheet/sheetTwo/HouseholdAppliances';
import ImportantNeeds from '@/components/sheet/sheetTwo/ImportantNeeds';
import IntangibleNeeds from '@/components/sheet/sheetTwo/IntangibleNeeds';
import OtherMaterialNeeds from '@/components/sheet/sheetTwo/OtherMaterialNeeds';
import SheetReflection from '@/components/sheet/sheetTwo/SheetReflection';
import SchoolSupplies from '@/components/sheet/sheetTwo/SchoolSupplies';
import SpecialGifts from '@/components/sheet/sheetTwo/SpecialGifts';
import SheetTwoVolunteers from '@/components/sheet/sheetTwo/SheetTwoVolunteers';
import AppLogo from '@/components/widgets/AppLogo';
import sheetTableOfContents from '@/components/widgets/sheet/SheetTableOfContents';
import SheetEndButtons from '@/components/widgets/sheet/sheetEndButtons';
import BaseIcon from '@/icons/BaseIcon';
import MenuIcon from '@/icons/MenuIcon';

import permissions from '@/constants/permissions';
import tableOfContents from '@/constants/sheet/sheetTwo';

import leaveConfirmDialog from '@/components/widgets/LeaveConfirmDialog';
import PageLoader from '@/components/widgets/PageLoader';
import postMeetingConsent from '@/constants/sheet/postMeetingConsent';
import auditPermissionsAndStatuses from '@/mixins/auditPermissionsAndStatuses';
import endButtonsCondition from '@/mixins/endButtonsCondition';
import isFamilyChecked from '@/mixins/sheet/isFamilyChecked';
import sheetBeforeLeave from '@/mixins/sheetBeforeLeave';
import AppModal from '@/components/widgets/AppModal.vue';

export default {
    name: 'SheetTwo',
    $_veeValidate: {
        validator: 'new'
    },
    components: {
        SheetTwoVolunteers,
        AppModal,
        PageLoader,
        AppLogo,
        sheetTableOfContents,
        FillInstruction,
        FirstMeeting,
        ChangeNames,
        MenuIcon,
        BaseIcon,
        SheetFood,
        CleaningProducts,
        SheetClothing,
        SchoolSupplies,
        ApartmentEquipment,
        HouseholdAppliances,
        OtherMaterialNeeds,
        IntangibleNeeds,
        SpecialGifts,
        ImportantNeeds,
        SheetTwoConsents,
        SheetReflection,
        SheetEndButtons,
        leaveConfirmDialog,
        FamilyAudit
    },
    mixins: [
        sheetBeforeLeave,
        auditPermissionsAndStatuses,
        endButtonsCondition,
        isFamilyChecked,
        postMeetingConsent
    ],
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            vm.$store.commit('sheet/clearSheetTwo');
            vm.$store.commit('sheet/setPartialSheetData', null);
            vm.$store.commit('sheet/setPartialSheetDataError', false);
            vm.$store.dispatch('sheet/getSheetPermissions', vm.$route.params.familyId);
            vm.$store
                .dispatch('family/getFamily', { id: vm.$route.params.familyId, endpointLabel: 'family' })
                .then(({ data }) => {
                    vm.$store.dispatch('audit/getAllAuditComments', 'needs');
                    vm.$store.dispatch('audit/getAuditComment', {
                        params: {
                            sheetType: 'needs'
                        }
                    });
                    vm.$store
                        .dispatch('sheet/loadSheetTwoResource', {
                            sheetId: 2,
                            editionName: data.edition.name
                        })
                        .finally(() => {
                            vm.resourceTwoLoading = false;
                        });
                });
            vm.$store
                .dispatch('sheet/loadSheet', { familyId: vm.$route.params.familyId, sheetType: 'needs' })
                .finally(() => {
                    vm.isSheetTwoLoading = false;
                    vm.partialDataError = vm.getPartialDataError;
                });
            vm.$store.commit('sheet/setCurrentRouteName', to.name);
            vm.$store.commit('sheet/setCurrentSelectorName', 'instruction');
        });
    },
    beforeRouteLeave (from, to, next) {
        if (this.isSheetChanged && !this.$store.getters['token/isForcedToLogout']) {
            this.$refs.confirm.dialog = true;
            this.$refs.confirm.open().then((confirm) => {
                if (confirm) {
                    this.$store.commit('sheet/clearSheetTwo');
                    this.$store.commit('family/setFamily', null);
                    next();
                } else {
                    next(false);
                }
            });
        } else {
            next();
        }
    },
    data () {
        return {
            tableOfContents,
            permissions,
            contentDialog: false,
            resourceTwoLoading: true,
            isSheetTwoLoading: true,
            partialDataError: false
        };
    },
    computed: {
        smAndUp () {
            return this.$vuetify.breakpoint.smAndUp;
        },
        isSheetChanged () {
            return Object.keys(this.fields).some((key) => this.fields[key].changed);
        },
        sheetPermissions () {
            return this.$store.getters['sheet/getSheetPermissions'];
        },
        readOnly () {
            if (this.getPartialDataError) return true;

            if (
                !this.canEditSheets ||
        (this.isFamilyVerifiedOnNational && !this.hasPermissionsForNationalCorrecting) ||
        !this.isCurrentEdition ||
        !this.isFamilyChecked
            ) {
                return true;
            }
            return !this.sheetPermissions.needs;
        },
        nextSectionName () {
            return this.isSheetReturned || this.canDoAuditInArea || this.canDoAuditOnNational
                ? 'Opisu'
                : 'Karty Rodziny';
        },
        nextSectionId () {
            return this.isSheetReturned || this.canDoAuditInArea || this.canDoAuditOnNational
                ? 'family-description'
                : 'family-card';
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        getPartialDataError () {
            return this.$store.getters['sheet/getPartialSheetDataError'];
        }
    },
    created () {
        this.$store.dispatch('sheet/addTableOfContentsList', tableOfContents);
    },
    methods: {
        viewHandler (e) {
            if (e.scrollPercent < 1) {
                if (e.target.rect.top <= 50) {
                    this.$store.commit('sheet/setCurrentSelectorName', e.target.element.id);
                }
            } else {
                if (e.percentTop <= 1) {
                    this.$store.commit('sheet/setCurrentSelectorName', e.target.element.id);
                }
            }
        },
        goToFamilyCard () {
            this.$router.push({ name: 'family-card', params: { id: this.$route.params.familyId } });
        }
    }
};
</script>

<style scoped></style>
